import React from "react";
import * as dc from "dc";
import * as d3 from "d3";
import reductio from "reductio";
import { ChartTemplate } from "../chartTemplate";

const crops_time_to_marketChartFun = (divRef, ndx) => {
    const county = ndx.dimension((d) => d.baseTbCode);

    //var crop_value_grp = county.groupAll().reduceSum(function (d) {

    //    return d.market_Travel_Time;

    //});

    const all = ndx.groupAll().reduceSum((d) => d.market_Travel_Time).value();
    let total_time_taken = all
    // custom reducer 
    const crop_value_grp = county.groupAll().reduce(
        /* callback for when data is added to the current filter results */
        function (p, v) {
            ++p.count;
            p.tot += v.market_Travel_Time;
            p.avg += v.market_Travel_Time / p.count;
            return p;
        },
        /* callback for when data is removed from the current filter results */
        function (p, v) {
            --p.count;
            p.tot -= v.market_Travel_Time;
            p.avg -= v.market_Travel_Time / p.count;
            return p;
        },
        /* initialize p */
        function () {
            return { count: 0, tot: 0, avg: 0 };
        }
    );
    //define the dc chart object

  const valueChart = dc.numberDisplay(divRef);
  valueChart
    .formatNumber(d3.format(",.2f"))
      .group(crop_value_grp)
      .on("pretransition  ", function (chart) {
          chart.valueAccessor((d) => {

              let a = d.tot

              let b = total_time_taken
              let record_count = d.count / 24 // the counties rows are dublicated 24 time 
              //console.log("b " + b)
              if (a < b && record_count == 1) {
                  //console.log("First if statement: " + a)
                  return a
              } else if (a < b && record_count > 1) {
                  return a / record_count
              } else if (a == b) {
                  

                  return a / 47
                  //console.log("second if statement: " + a)
              }
          });
      })
      .valueAccessor((d) => {
          return d.tot / 47;

      });


  return valueChart;
};

export const TravelTimeCrop = (props) => (
  <ChartTemplate chartFunction={crops_time_to_marketChartFun} />
);
